module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MCIgaGVpZ2h0PSI1MCI+CiAgPGxpbmUgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjYTZiZGMzIiBzdHJva2Utd2lkdGg9IjUiIHgxPSIyIiB5MT0iMjUiIHgyPSI0OCIgeTI9IjI1IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KICA8bGluZSBmaWxsPSJub25lIiBzdHJva2U9IiNhNmJkYzMiIHN0cm9rZS13aWR0aD0iNSIgeDE9IjI1IiB5MT0iMiIgeDI9IjI1IiB5Mj0iNDgiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/images/svg/plus-orange.svg
// module id = 115
// module chunks = 76542744693416 101412927793125 153072797211167